module.exports = __webpack_public_path__ + "img/SMATIVOS-LIGHT.62505e04.jpg";